/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useBookingCalendarLink = (id, queryParams) => {
  return useQuery({
    queryKey: queryKeys.booking.calendarLink(id),
    queryFn: async () => {
      const response = await fetcher({ method: "GET", url: `/public/booking/ical/id/${id}`, params: { batch: 1 } });
      const blob = new Blob([response]);
      return URL.createObjectURL(blob);
    },
    ...queryParams,
  });
};
